import { useEffect } from 'react';

import notification from '@app/shared/utils/notification';

export const useDisplayError = (displayError: boolean, errorMsg: string) => {
  useEffect(() => {
    if (displayError) {
      notification.error(errorMsg);
    }
  }, [displayError, errorMsg]);
};
